"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownload = void 0;
var useDownload = function () {
    var createLink = function (_a) {
        var href = _a.href, filename = _a.filename;
        var link = document.createElement('a');
        link.href = href;
        link.target = '_blank';
        // filename can be set in headers
        if (filename)
            link.setAttribute('download', filename);
        return link;
    };
    var download = function (_a) {
        var props = __rest(_a, []);
        var link = createLink(__assign({}, props));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return { download: download };
};
exports.useDownload = useDownload;
